import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultant-project',
  templateUrl: './consultant-project.component.html',
  styleUrls: ['./consultant-project.component.scss']
})
export class ConsultantProjectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
